<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>


                <li @mouseover="showCadastrosMenu = true" @mouseleave="showCadastrosMenu = false">
                    <img src="@/assets/icons/menuOpcoes.svg" />
                    <span>Cadastros</span>
                    <div v-if="showCadastrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('BairrosTabPage', 'BAIRROS')">
                                <span>Bairros</span>
                            </li>
                            <li @click="selectOption('FornecedoresTabPage', 'FORNECEDORES')">
                                <span>Fornecedores</span>
                            </li>
                            <li @click="selectOption('DespesasGruposTabPage', 'GRUPOS DE DESPESAS')">
                                <span>Grupos de Despesas</span>
                            </li>
                            <li @click="selectOption('ProdutosTabPage', 'MATERIAIS')">
                                <span>Materiais</span>
                            </li>
                            <li @click="selectOption('OperadoresTabPage', 'OPERADORES SERVIÇOS DE IP')">
                                <span>Operadores</span>
                            </li>
                            <li @click="selectOption('PessoasTabPage', 'PESSOAS')">
                                <span>Pessoas e Produtores</span>
                            </li>
                            <li @click="selectOption('IpServicosTabPage', 'SERVIÇOS ILUMINAÇÃO PÚBLICA')">
                                <span>Serviços</span>
                            </li>
                            <li v-if="globalStore.perfil.sis_admin===1" @click="selectOption('UsuariosTabPage', 'USUÁRIOS')">
                                <span>Usuários</span>
                            </li>
                        </ul>
                    </div>
                </li>
                

                <li @mouseover="showExtrasMenu = true" @mouseleave="showExtrasMenu = false">
                    <img src="@/assets/icons/menuEdit.svg" />
                    <span>Ações</span>
                    <div v-if="showExtrasMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('IpOsSolicitacoesAnaliseTabPage', 'ANÁLISE DE SOLICITAÇÕES')">
                                <span>Analisar Solicitações de Serviços</span>
                            </li>

                            <li @click="selectOption('IpOsAutorizacaoTabPage', 'AUTORIZAR EXECUÇÃO DE SERVIÇO')">
                                <span>Autorizar Execução de Serviços</span>
                            </li>

                            <li @click="selectOption('IpOsAlteracaoPage', 'IP - ALTERAR ORDEM DE SERVIÇO EMITIDA')">
                                <span>Alterar OS Emitida</span>
                            </li>

                            <li @click="selectOption('IpOsCancelamentoPage', 'IP - CANCELAR ORDEM DE SERVIÇO')">
                                <span>Cancelamento de OS</span>
                            </li>

                            <li @click="selectOption('IpOsEstornoEncerramentoPage', 'IP - ESTORNAR ENCERRAMENTO DE SERVIÇO')">
                                <span>Estornar Encerramento de OS</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('IpOsSolicitacoesTabPage', 'SERVIÇOS SOLICITADOS')">
                    <img src="@/assets/icons/menuPhone.svg" />
                    <span>Serviços Solicitados</span>
                </li>

                <li @click="setComponenteAtivo('IpOsEditPage', 'EMITIR ORDEM DE SERVIÇO')">
                    <img src="@/assets/icons/menuEngineer2.svg" />
                    <span>Emitir Ordem de Serviço</span>
                </li>

                <li @click="setComponenteAtivo('IpOsEditItensPage', 'BAIXAR ORDEM DE SERVIÇO')">
                    <img src="@/assets/icons/menuCheckDuplo.svg" />
                    <span>Baixar Ordem de Serviço</span>
                </li>

                <li @click="setComponenteAtivo('IpOsAdminTabPage', 'ORDENS DE SERVIÇO')">
                    <img src="@/assets/icons/menuDados.svg" />
                    <span>Ordens de Serviço</span>
                </li>

                <li @click="setComponenteAtivo('IpOsMapaPage', 'ILUMINAÇÃO PÚBLICA - MAPA')">
                    <img src="@/assets/icons/menuMap.svg" />
                    <span>Mapa Geral</span>
                </li>

                <li @mouseover="showCadastrosRelatorios = true" @mouseleave="showCadastrosRelatorios = false">
                    <img src="@/assets/icons/menuPrinter.svg" />
                    <span>Relatórios</span>
                    <div v-if="showCadastrosRelatorios" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('IpOSGeralReportPage', 'LISTAGEM GERAL DE O.S. EMITIDAS')">
                                <span>Listagem Geral</span>
                            </li>
                            <li @click="selectOption('IpOSMaterialConsumidoReportPage', 'TOTAL DE MATERIAL CONSUMIDO')">
                                <span>Total Material Consumido</span>
                            </li>
                        </ul>
                    </div>
                </li>

                <li @click="setComponenteAtivo('UsuarioViewPage', 'DADOS DO USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Meus Dados</span>
                </li>

                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GESTÃO ILUMINAÇÃO PÚBLICA' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ loginStore.userData.nome }}</div>
                        <div class="establishment-name">{{ loginStore.userData.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='BairrosTabPage'"><BairrosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DespesasGruposTabPage'"><DespesasGruposTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FornecedoresTabPage'"><FornecedoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsAdminTabPage'"><IpOsAdminTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsAlteracaoPage'"><IpOsAlteracaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsAutorizacaoTabPage'"><IpOsAutorizacaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsCancelamentoPage'"><IpOsCancelamentoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsEditPage'"><IpOsEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsEditItensPage'"><IpOsEditItensPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsEstornoEncerramentoPage'"><IpOsEstornoEncerramentoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOSGeralReportPage'"><IpOSGeralReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsMapaPage'"><IpOsMapaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOSMaterialConsumidoReportPage'"><IpOSMaterialConsumidoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsSolicitacoesTabPage'"><IpOsSolicitacoesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpOsSolicitacoesAnaliseTabPage'"><IpOsSolicitacoesAnaliseTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='IpServicosTabPage'"><IpServicosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='LogradourosTabPage'"><LogradourosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='OperadoresTabPage'"><OperadoresTabPage :cdPerfil="5" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PessoasTabPage'"><PessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosTabPage'"><ProdutosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else><IpOSAdminDash /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';

import BairrosTabPage from '../cadastros/tabelas/BairrosTabPage.vue';
import DespesasGruposTabPage from '../cadastros/tabelas/DespesasGruposTabPage.vue';
import FornecedoresTabPage from '../cadastros/tabelas/FornecedoresTabPage.vue';
import IpOSAdminDash from '../dashboard/IpOSAdminDash.vue';
import IpOsAdminTabPage from '../ip/IpOsAdminTabPage.vue';
import IpOsAlteracaoPage from '../ip/IpOsAlteracaoPage.vue';
import IpOsAutorizacaoTabPage from '../ip/tabelas/IpOsAutorizacaoTabPage.vue';
import IpOsCancelamentoPage from '../ip/IpOsCancelamentoPage.vue';
import IpOsEditPage from '../ip/IpOsEditPage.vue';
import IpOsEditItensPage from '../ip/IpOsEditItensPage.vue';
import IpOsEstornoEncerramentoPage from '../ip/IpOsEstornoEncerramentoPage.vue';
import IpOSGeralReportPage from '../reports/IpOSGeralReportPage.vue';
import IpOsMapaPage from '../ip/IpOsMapaPage.vue';
import IpOSMaterialConsumidoReportPage from '../reports/IpOSMaterialConsumidoReportPage.vue';
import IpOsSolicitacoesAnaliseTabPage from '../ip/tabelas/IpOsSolicitacoesAnaliseTabPage.vue';
import IpOsSolicitacoesTabPage from '../ip/IpOsSolicitacoesTabPage.vue';
import IpServicosTabPage from '../cadastros/tabelas/IpServicosTabPage.vue';
import LogradourosTabPage from '../cadastros/tabelas/LogradourosTabPage.vue';
import OperadoresTabPage from '../cadastros/tabelas/OperadoresTabPage.vue';
import PessoasTabPage from '../cadastros/tabelas/PessoasTabPage.vue';
import ProdutosTabPage from '../cadastros/tabelas/ProdutosTabPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showCadastrosMenu = ref(false);
const showCadastrosRelatorios = ref(false);
const showExtrasMenu = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;

const menuIcon = computed(() =>
  isCollapsed.value
    ? require('@/assets/icons/menuRight.svg')
    : require('@/assets/icons/menuLeft.svg')
);

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showCadastrosMenu.value = false; // Fecha o submenu após a seleção
    showCadastrosRelatorios.value=false;
    showExtrasMenu.value=false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>

<style scoped src="@/assets/css/main.css"></style>
